import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import ShippingInstructionRequestViewForm from './ShippingInstructionRequestViewForm'
import ShippingInstructionRequestAddForm from './ShippingInstructionRequestAddForm'
import ShippingInstructionRequestEditForm from './ShippingInstructionRequestEditForm'
import Namespace from 'src/constants/locale/Namespace'
import ShippingInstructionRequestKeys from 'src/constants/locale/key/ShippingInstructionRequest'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      UiComponentKeys,
    },
  },
} = constants

const { CngTabs } = components

function AddPage({ history, showNotification }) {
  const [lockedOnFirstTab, setLockedOnFirstTab] = useState(true)
  const [shippingInstructionRequestId, setShippingInstructionRequestId] = useState('')
  const { translate } = useTranslation([
    Namespace.SHIPPING_INSTRUCTION_REQUEST,
    Namespace.UI_COMPONENT
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let shippingInstructionRequest = translate(
      Namespace.SHIPPING_INSTRUCTION_REQUEST,
      ShippingInstructionRequestKeys.TITLE
    )
    let tabLockedMessage = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Tabs.PLEASE_SUBMIT_FIRST,
      {
        title: shippingInstructionRequest
      }
    )

    return {
      shippingInstructionRequest,
      tabLockedMessage
    }
  }

  function makeShippingInstructionRequestForm() {
    if (shippingInstructionRequestId === '') {
      return (
        <ShippingInstructionRequestAddForm
          history={history}
          showNotification={showNotification}
          onPostSubmitSuccess={(datum) => {
            setShippingInstructionRequestId(datum.id)
            setLockedOnFirstTab(false)
          }}
        />
      )
    } else {
      return (
        <ShippingInstructionRequestEditForm
          showNotification={showNotification}
          id={shippingInstructionRequestId}
        />
      )
    }
  }

  return (
    <Grid container spacing={3}>
      {/* <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <ShippingInstructionRequestViewForm
              showNotification={showNotification}
              id={shippingInstructionRequestId}
            />
          </Container>
        </Paper>
      </Grid> */}
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.shippingInstructionRequest,
              tabContent: makeShippingInstructionRequestForm()
            },
          ]}
          lockedOnFirstTab={lockedOnFirstTab}
          tabLockedMessage={translatedTextsObject.tabLockedMessage}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage